// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37771954","624":"daa703e6"}[chunkId] + ".chunk.js";
};